import { axios } from 'system/axios'

export const uploadAvatar = () => axios.post<{ signedUrl: string }>('/user/me/avatar')
